<template>
  <div>
    <div class="text-xs-right" style="padding:0; height:8px; position:absolute; top:0; right:0;"  >
      <v-btn icon color="#508FBF">
        <v-icon @click ="iniciarTour ">live_help</v-icon>
      </v-btn>
    </div>
    <v-layout row wrap class="mt-2 mb-2 pa-3">
      <v-flex xs12 sm2 md2>
        <Select
          style="width: 92%;"
          label="Ano Letivo"
          v-model="anoSelecionado"
          :disabled="loading"
          :options="anos()"
          @change="mudarAno"
          ref="inputAnoLetivo"
          tabindex="1"
        />
      </v-flex>

      <v-flex xs12 sm2 md2>
        <select-ajax
            label="Turma"
            :disabled="loading"
            rota='ei/turma/select-turmas-professor'
            :params="{ ...userProfessor,  ...school, aaletivo: anoSelecionado }"
            ref="turmas"
            contador
            opcaoTodos="Todas"
            chave="cdturma"
            :valor="(item) => `${item.nmturma} ${item.horario ? ' - ' + item.horario : ''}`"
            v-model="turmaSelecionado"
            :v="$v.turmaSelecionado"
            @change="mudarTurma()">
        </select-ajax>
      </v-flex>
      <v-flex xs12 sm2 md2>
        <select-ajax
            label="Professores/Educadores"
            v-if="exibirComboboxProfessores"
            class="comboboxprofessores"
            :disabled="loading"
            rota='ei/turma/turmas-professor-disciplina'
            :params="{ ...userProfessor,
                      ...school,
                       aaletivo: anoSelecionado,
                       cdturma: (turmaSelecionado === -1 || turmaSelecionado === '' ) ? filtroTurma.map(element => element.value) : [turmaSelecionado],
                      identificadorperfilatual:userDadosPerfilAtual.identificadorperfil
                      }"
            ref="professores"
            :resultado='["professores"]'
            contador
            opcaoTodos="Todos"
            :chave="(item) => `${item.cdpessoal}${item.cdmatric}`"
            :valor="(item) => `${item.cdpessoal}-${item.cdmatric} - ${item.nmfuncion}`"
            v-model="professorSelecionado"
            :v="$v.cdmatric"
             @change="mudarProfessor()">
          </select-ajax>
      </v-flex>
      <v-flex xs12 sm12 md6 class="text-xs-right text-right " >
        <div data-v-step="2" style="display: inline-block" >
      <v-btn id="BotaoAtalhoAulasFrequencia" width="310px"  class="second rounded-sm" style="margin-top:8px; color:white; height: 50px; text-align: center; font-weight: 400;  font-size: 14px; word-spacing: -3px;" :to="{ name: 'diario-escolar-regente', params: { ano: anoSelecionado}  }" alt="teste">
             <v-icon data-v-step="2" style="transform: rotateY(180deg); font-size: 25px; "  >reply</v-icon>
             &nbsp Atalho para Aulas/ Frequência
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-card>
        <div>
          <table class="table-siged">
            <thead>
              <tr>
                <th>Turmas</th>
                <th  >Disciplinas/Campos de Experiência</th>
                <th colspan="5">Ações</th>
              </tr>
            </thead>
            <tbody v-if=" this.loading === false">
              <tr class="table-not-found" v-if="listagem.length == 0 && this.loading === false">
                <td colspan="7">Nenhuma turma encontrada!</td>
              </tr>
              <tr v-else v-for="item in listagem" :key="item.id">
                <td>{{ item.nmturma }} {{ getTurno(item.cnperiodo) }}</td>
                <td>{{ item.dsdiscipl }}</td>
                <td class="centro">
                  <v-menu bottom left >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on"  icon style="color: gray" ><v-icon data-v-step="1" >more_vert</v-icon> </v-btn>

                    </template>
                    <v-list >
                      <v-list-item class="table-siged-menu" :to="{ name: 'diario-escolar-aulas', params: parametrosLink(item, 'Aulas')  }">
                        <v-list-item-title>
                            Aulas Lecionada/Frequência
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="verificaTipoNotas(item.cntpregdi, 'N')" class="table-siged-menu" :to="{ name: 'diario-escolar-lancar-notas', params: parametrosLink(item, 'Notas') }">
                        <v-list-item-title>
                            Lançar Notas
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="verificaTipoNotas(item.cntpregdi, 'C')" class="table-siged-menu" :to="{ name: 'diario-escolar-lancar-conceito', params: parametrosLink(item, 'Conceito') }">
                        <v-list-item-title>
                            Lançar Conceito
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="userDadosPerfilAtual.identificadorperfil === 1 || userDadosPerfilAtual.identificadorperfil === 2 || userDadosPerfilAtual.identificadorperfil === 3" class="table-siged-menu" :to="{ name: 'diario-escolar-perfil-turma', params: parametrosLink(item, 'Perfil da Turma') }">
                        <v-list-item-title>
                             Perfil da turma
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="item.AEEouACP === false" class="table-siged-menu" :to="{ name: 'diario-escolar-parecer-descritivo', params: parametrosLink(item, 'Parecer Descritivo') }">
                        <v-list-item-title>
                             Parecer Descritivo
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="item.AEEouACP === true" class="table-siged-menu" :to="{ name: 'diario-escolar-parecer-descritivo-aee-acp', params: parametrosLink(item, 'Parecer Descritivo AEE/Acompanhamento Pedagógico') }">
                        <v-list-item-title>
                          Parecer Circunstanciado
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item class="table-siged-menu" v-if="exibirPlanejamento()">
                        <v-list-item-title>
                             Planejamento de ensino
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="!item.AEEouACP" class="table-siged-menu" :to="{ name: 'diario-escolar-totalizador-nota', params: parametrosLink(item, 'Totalizador Nota') }">
                        <v-list-item-title>
                             Totalizador Nota/Freq.
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item class="table-siged-menu" v-if="item.cancelavel" :to="{ name: 'diario-escolar-cancelar-diario', params: { ...parametroPeriodos(item) } }">
                        <v-list-item-title>
                             Cancelar Diário
                        </v-list-item-title>
                      </v-list-item>

                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-siged" style="text-align: right" v-if="quantidadePaginas > 1 && this.loading === false">
            <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="9" @input="reload(null)"/>
          </div>
        </div>
      </v-card>
    </v-flex>
    <div data-v-step="0" style="margin-left:200px;" ></div>
  <div>

  <v-tour name="my-tour" :steps="steps" class="text-body-2" >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step style=""
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
        >
          <template v-if="tour.currentStep === 0"  style="float: 100px;">
            <div slot="actions"  >
              <button @click="finalizaTour(tour)" class="btn btn-primary " style="margin-right: 15px;">Encerrar</button>
              <button @click="tour.nextStep" class="btn btn-primary " style="" v-if="listagem.length > 0">Próximo</button>
            </div>
          </template>

          <template v-if="tour.currentStep === 1"  style="float: 100px;">
            <div slot="actions"  >
              <button @click="tour.previousStep" class="btn btn-primary" style="margin-right: 15px;">Voltar</button>
              <button @click="finalizaTour(tour)" class="btn btn-primary " style="margin-right: 15px;">Encerrar</button>
              <button @click="tour.nextStep" class="btn btn-primary" style="" v-if="liberaMenuRegente">Próximo</button>
            </div>
          </template>

          <template v-if="tour.currentStep === 2"  style="float: 100px;" >
            <div slot="actions"  >
              <button @click="tour.previousStep" class="btn btn-primary" style="margin-right: 15px;">Voltar</button>
              <button @click=" finalizaTour(tour)" class="btn btn-primary" style="">Encerrar</button>
            </div>
          </template>

          <template v-if="tour.currentStep === 3"  style="float: 100px;">
            <div slot="actions"  >
              <button @click="tour.previousStep" class="btn btn-primary" style="margin-right: 15px;">Voltar</button>
              <button @click="tour.stop" class="btn btn-primary" style="">Encerrar</button>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>

  </div></div>
</template>

<script>
import { mapGetters} from 'vuex';
import store from '@/store/index';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import _ from 'lodash';
import SelectAjax from '@/components/SelectAjax'
const TurmasRepository = RepositoryFactory.get('turma');
//import { maxLength} from 'vuelidate/lib/validators';
import { ehTurmaAEEouACP } from '@/utils/turmas'


const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
  name: 'TurmasProfessor',
  name: 'my-tour',
  components: {
    SelectAjax
  },
  props: {
    paginaAtualTurmas: [String, Number],
  },
  data(){
    return {
        steps: [
          {
            target: '[data-v-step="0"]',
            content: `Nesta tabela, estão listadas as turmas e disciplinas autorizadas para lançamento.`
          },
          {
            target: '[data-v-step="1"]',
            content: 'Clique aqui para acessar o menu de opções para lançar notas, frequências e outros.',
            params: {
              placement: 'bottom'
            }
          },
          {
            target: '[data-v-step="2"]',
            content: 'Função para lançar múltiplas aulas para várias disciplinas de uma turma. Vantajoso para professor regente',
            params: {
              placement: 'left'
            }
          }
        ],
      anoSelecionado: null,
      anofiltro: null,
      turmaSelecionado: '',
      professorSelecionado:'',
      cdpessoal: '',
      cdmatric: '',
      listagem: [],
      turmasCancelaveis: [],
      filtroTurma: [],
      filtroProfessorTurma: [],
      anoAtual: 2021,
      loading: true,
      paginaAtual: 1,
      quantidadePaginas: 0,
      checkRegente: false,
      dadosTodasTurmas: [],
      idMudouFiltroTurma: null,
      idMudouFiltroProfessor: null,
      idMudouFiltroAnoLetivo: null,
      todasAsTurmas: []
    };
  },

  validations() {
    return {
      turmaSelecionado: {  },
      cdmatric: {}
    }
  },
   mounted: function () {
     if ((localStorage.getItem(`tour-${this.email}`) == "true") || (localStorage.getItem(`tour-${this.email}`) == null)){
      this.$tours['my-tour'].start()
      localStorage.setItem(`tour-${this.email}`,"true");
     }
    },
  async beforeRouteEnter (to, from, next) {
    try{
      const { data } = await DiarioEscolarRepository.getTurmas({ ...dadosUser(), page: to.params.paginaAtualTurmas || 1, cdturma: '' });
      next(vm => vm.reload(data));

    }
    catch(e){
      // next('/');
    }
  },
  watch: {
    anoSelecionado(valorNew, valorOld) {
      if(valorOld !== null && valorOld !== '' && valorNew !== valorOld) { this.paginaAtual = 1; }
    },
  },
  methods: {
    mudarAno() {
      this.paginaAtual = 1;
      this.professorSelecionado = -1;
      this.idMudouFiltroAnoLetivo = true;
      this.$refs.turmas.limpar();
      this.reload();
    },
    mudarTurma() {
      this.paginaAtual = 1;
      this.professorSelecionado = -1;
      this.idMudouFiltroTurma = true;
      if (this.exibirComboboxProfessores === true)
        this.$refs.professores.limpar();
      if (this.$refs.turmas.obterlista().length > 0)
      this.reload();
    },
    mudarProfessor() {
      this.paginaAtual = 1;
      this.listagem = [];
      this.idMudouFiltroProfessor =true;
      if (this.$refs.professores.obterlista().length > 0 && this.exibirComboboxProfessores === true)
      this.reload(this.dadosTodasTurmas);
    },
    async reload(data = null){
      this.loading = true;
       setTimeout(() => document.getElementById('BotaoAtalhoAulasFrequencia').focus(), 200);

      try{
        if(!data){
          this.$Progress.start();
          const response = await DiarioEscolarRepository.getTurmas({ ...dadosUser(),
                                                                    aaletivo: this.anoSelecionado,
                                                                    page: this.paginaAtual,
                                                                    cdturma: (this.turmaSelecionado === -1 || this.turmaSelecionado ==='' ) ? '' : this.turmaSelecionado
                                                                  });
          data = response.data;
          this.dadosTodasTurmas = data;
        }
        else{
          if (this.idMudouFiltroAnoLetivo === null) {
            this.anoSelecionado = data.results.anoAtual;
            this.anofiltro = data.results.anoAtual;

          }

        }


        if (this.idMudouFiltroTurma === true || this.idMudouFiltroAnoLetivo === true) {


          let turmas = this.dadosTodasTurmas.results.todasTurmasProfessor;
          this.filtroTurma = turmas.map(turma =>{
                        return {
                          value: turma.key || turma.cdturma,
                          text: turma.value || turma.cdturma,
                        };
                  });

        }

          this.listagem = data.results.turmasProfessor.data;
          this.listagem = this.listagem.map( t => {
                                                    return {
                                                      ...t,
                                                      AEEouACP:ehTurmaAEEouACP(t.cdtpatend, t.cdinstruc, t.cdserie),
                                                      cancelavel: data.results.turmasCancelaveis.some((tc) => tc.cdturma == t.cdturma && tc.cddiscipl == t.cddiscipl && tc.cdinstruc == t.cdinstruc && tc.cdserie == t.cdserie),
                                                      periodosCancelaveis: data.results.turmasCancelaveis.filter(
                                                        (tc) => tc.cdturma == t.cdturma && tc.cddiscipl == t.cddiscipl && tc.cdinstruc == t.cdinstruc && tc.cdserie == t.cdserie
                                                      ).map(
                                                        (tc) => {
                                                          return { cdpravadi: tc.periodo_avaliativo.cdpravadi, dspravadi: tc.periodo_avaliativo.dspravadi}
                                                        }
                                                      )
                                                    }
                                                  }
                                            )

          this.quantidadePaginas = data.results.turmasProfessor.last_page;
          this.anoAtual = data.results.anoAtual;
          this.checkRegente = data.results.regente;
          this.paginaAtual = data.results.turmasProfessor.current_page;

          if ( this.exibirComboboxProfessores) {
               if (this.professorSelecionado !== -1 && this.professorSelecionado !== '') {
                    const turmasDoProfessorSelecionado = await TurmasRepository.getSelectTurmasUmProfessor({
                    aaletivo: this.anoSelecionado,
                    cdtipesc: dadosUser().cdtipesc,
                    cdescola: dadosUser().cdescola,
                    cdpessoal: this.professorSelecionado[0],
                    cdmatric: this.professorSelecionado.slice(1, this.professorSelecionado.length),
                    cdturma: (this.turmaSelecionado === -1 || this.turmaSelecionado === '' ) ? this.filtroTurma.map(element => element.value) : [this.turmaSelecionado]
                  });

                  this.listagem = turmasDoProfessorSelecionado.data.results;
                  this.quantidadePaginas = 1;
                  this.checkRegente = true;
                  this.paginaAtual = 1;
                }

          }


      this.idMudouFiltroTurma= false,
      this.idMudouFiltroProfessor= false,
      this.idMudouFiltroAnoLetivo= false
      }
      catch(e){ }
      this.loading = false;
      this.$Progress.finish();
    },
    anos() {
      if(!this.anoAtual)
        return [];

      let ultimosAnos = [];
      const anoiniciodiario = 2019;

      for(let ano = this.anoAtual; ano >= anoiniciodiario; ano--)
        ultimosAnos.push({ value: ano, text: ano });
      return ultimosAnos;
    },
    parametrosLink(dados, descricao){
      return {
        ano: this.anoSelecionado,
        cdturma: dados.cdturma,
        nmturma: dados.nmturma,
        disciplina: dados.cddiscipl,
        descricaDisciplina: dados.dsdiscipl,
        descricao,
        paginaAtualTurmas: this.paginaAtual,
        tipoDeEnsino: dados.cntpensin,
        cdinstruc: dados.cdinstruc,
        cdserie:  dados.cdserie,
        AEEouACP:ehTurmaAEEouACP(dados.cdtpatend, dados.cdinstruc, dados.cdserie),

        // Esta linha foi comentada para retirar os campos de experiência,
        // os quais podem voltar a ser precisos a qq momento
        //Para voltar com eles, basta descomentar este comando e retirar o comando
        //'this.tipodeensino = F' abaixo

       //tipoDeEnsino: 'F',
      }
    },
    parametroPeriodos(dados) {
      return {
        ...this.parametrosLink(dados),
        periodos: dados.periodosCancelaveis,
        cdtipesc: dadosUser().cdtipesc,
        cdescola: dadosUser().cdescola,
        cdpessoal: dadosUser().cdpessoal,
        cdmatric: dadosUser().cdmatric,
        tipoAvaliacao: this.verificaTipoNotas(dados.cntpregdi, 'N') ? 'N' : this.verificaTipoNotas(dados.cntpregdi, 'C') ? 'C' : ''
      }
    },
    getTurno(data) {
      switch(data) {
        case 'M': return '- Matutino';
        case 'V': return '- Vespertino';
        case 'N': return '- Noturno';
        case 'I': return '- Integral';
        default: return '';
      }
    },
    exibirPlanejamento() {
      const { identificadorperfil } = this.$store.getters.userDadosPerfilAtual;
      return identificadorperfil === 1;
    },
    finalizaTour(tour) {
     localStorage[`tour-${this.email}`] = "false";
      tour.stop();
    },
    iniciarTour(){
      localStorage.setItem(`tour-${this.email}`,"true");
      this.$tours['my-tour'].start();
    },
    verificaTipoNotas(cntpregdi, tipo) {
      return cntpregdi.indexOf('A') >= 0 || cntpregdi.indexOf(tipo) >= 0;
    }
  },
  computed: {
    ...mapGetters(['email' , 'getAnoAtualServidor', 'userDadosPerfilAtual', 'userProfessor', 'school']),
    liberaMenuRegente(){
      return this.checkRegente;
    },
    exibirComboboxProfessores() {
       return this.userDadosPerfilAtual.identificadorperfil === 8 ||
              this.userDadosPerfilAtual.identificadorperfil === 6 ||
              this.userDadosPerfilAtual.identificadorperfil === 1 ;
    },
    exibirCancelarDiario() {
      return true;
    },
    professor: {
      get() {
        return this.cdmatric == -1 ? this.cdmatric : `${this.cdpessoal}-${this.cdmatric}`;
      },
      set(value) {
        if (value === -1 || value === "") {
          this.cdpessoal = '';
          this.cdmatric = value;
          return;
        }
        [this.cdpessoal, this.cdmatric] = value.split('-');
      }
    }
  },
}
</script>

<!-- o style abaixo é para customizar os balões do vuetour-->
<style lang="scss">
.escola-card-dados{
  display: block;
  padding: 10px 16px;

  .escola-card-dados-itens{
    display: flex;
    div{
      flex: 1
    }
  }
}

.v-step{
  background-color: #00877A!important;
 //background-color: white!important;
  border-radius: 40px 40px 40px 40px !important;
  //color:black;
  //left: -10px!important;


}
.v-step__arrow {
    border-color: #00877A !important;
   //border-color:  white!important;
    transform: rotate(45deg);
    height: 20px!important;
    width: 20px!important;
    background-color: #00877A;
    //left: -10px!important;
  // background-color:  white!important;
}

@media screen and (max-width: 600px ) {
  .comboboxprofessores {
      width: 100%;

  }

}
@media screen and (min-width: 601px ) {
  .comboboxprofessores {
      width: 550px;
      margin-left: 20px;
  }

}

@media screen and (min-width: 400px ) {
  .comboboxprofessores {
      width: 350px;
      margin-left: 20px;
  }

}

.table-siged-menu {
  &:hover {
    background-color: #A3DFEB;

  }
}

// .v-step__content{
//   color:black;
// }
</style>
